import { ScrollTarget } from 'models';

export const onClickScrollToTarget = (target?: ScrollTarget) => {
  if (target && target.ref && typeof target.ref.scrollIntoView === 'function') {
    target.ref.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  } else if (target && typeof target.scrollTo !== 'undefined') {
    // 0 should be valid!
    window.scrollTo(0, target.scrollTo);
  }

  if (target && target.ref && typeof target.ref.focus === 'function') {
    target.ref.focus();
  }
};
